import React from 'react';
import { BoxProps } from '@mui/material/Box';
import { Box } from '../box';

export function AreaBox(props: BoxProps) {
  const defaults = {
    mb: 2,
  };

  return <Box {...{ ...defaults, ...props }} />;
}
